//#region Utils
import { errorFree } from "utils/validations";
import { EVENTS_CONSTANTS } from "config/constants";
import { getDayIdByTimestamp2 } from "components/CustomDatePicker/utils/helpers";
import {
	CERTIFICATION_SIGNATURE_SOURCE_STATUS,
	hasDuplicateSignatureTypes,
	isInstitutionalCertificationSignature,
	isCertificationSpeakerResolved,
	signatureRequiresSpeakerData,
} from "views/Eventos/utils/certification";
//#endregion

const { EVENT_TYPES, EVENT_PERIOD_IDS } = EVENTS_CONSTANTS;

//#region Validators
//validación de errores formulario (step1, step2)
const isValidFormStep1 = (step1, errors, ignoreDurationFields) => {
	const { title, description } = step1.part1;
	const {
		eventTypeId,
		eventSubtypeId,
		hasSubtype,
		hasSectionSubtype,
		eventGraphicId,
		complementaryServiceAreaId,
		sectionSubtype
	} = step1.part2;
	const { period, duration, hasWaitlist } = step1.part3;
	const newErrors = {
		part1: {
			title: !title.trim(),
			description: !description.trim(),
		},
		part2: {
			eventTypeId: eventTypeId === 0,
			eventSubtypeId:
				eventTypeId > 0 && hasSubtype && eventSubtypeId === 0,
			eventGraphicId: eventGraphicId === 0,
			complementaryServiceAreaId: complementaryServiceAreaId === 0,
			sectionSubtype: 
				hasSectionSubtype && sectionSubtype === 0
		},
		part3: {
			period: !Boolean(period),
			hasWaitlist: false,
			duration: {
				onlyDay: {
					date: false,
					time: {
						start: false,
						end: false,
						areInvalidTimes: false,
					},
				},
				manyDays: {
					date: {
						start: false,
						end: false,
						waitlist: false,
					},
					days: false,
					areInvalidDates: false,
					isValidWaitlist: false,
					isValidDaysCheckbox: false,
					time: errors.step1.part3.duration.manyDays.time.map(
						({ dayId }) => {
							return {
								dayId,
								start: false,
								end: false,
								areInvalidTimes: false,
							};
						}
					),
				},
			},
		},
	};
	if (period === EVENT_PERIOD_IDS.ONLY_DAY && !ignoreDurationFields.onlyDay) {
		const { date, time } = duration.onlyDay;
		const errorTime = {
			start: time.start <= -1,
			end: time.end <= -1,
		};
		newErrors.part3.duration.onlyDay = {
			date: date <= -1,
			time: errorTime,
			areInvalidTimes:
				!errorTime.start && !errorTime.end && time.start >= time.end,
		};
	} else if (
		period === EVENT_PERIOD_IDS.MANY_DAYS &&

		!ignoreDurationFields.manyDays
	) {	
		const { date, days, time } = duration.manyDays;
		const isCulturalOrSport = (eventSubtypeId == EVENTS_CONSTANTS.EVENT_SUBTYPES.CULTURAL || eventSubtypeId == EVENTS_CONSTANTS.EVENT_SUBTYPES.SPORT);
		const isProfessionalTools = (eventSubtypeId == EVENTS_CONSTANTS.EVENT_SUBTYPES.PROFESSIONAL_TOOLS);
		const errorDate = {
			start: date.start <= -1,
			end: date.end <= -1,
			waitlist: hasWaitlist && isCulturalOrSport && date.waitlist <= -1
		};
		newErrors.part3.duration.manyDays = {
			date: errorDate,
			areInvalidDates:
				!errorDate.start && !errorDate.end && date.start >= date.end,
			isValidWaitlist:
				hasWaitlist && !isProfessionalTools && !(date.waitlist > date.start && date.waitlist < date.end),
			isValidDaysCheckbox:
				!(days.some(x => x === getDayIdByTimestamp2(date.start))) ||
				!(days.some(x => x === getDayIdByTimestamp2(date.end))),
			days: days.length === 0,
			time: time.map(({ dayId, start, end }) => {
				const errorTime = {
					start: start <= -1,
					end: end <= -1,
				};
				return {
					dayId,
					start: start <= -1,
					end: end <= -1,
					areInvalidTimes:
						!errorTime.start && !errorTime.end && start >= end,
				};
			}),
		};
	}
	const isValid = errorFree(newErrors);
	return {
		isValid,
		newErrors,
	};
};
function isValidPayGradeId({ eventTypeId, payGradeId }) {
	return Boolean(eventTypeId !== EVENT_TYPES.WORK_SHOP || payGradeId);
}
const isValidFormStep2 = (step2, { eventTypeId, teacherZoomAccountDetail }) => {
	const {
		organizerId,
		teacher, payGradeId, placeOrganization
	} = step2.part1;
	const {
		locationId, zoomTypeId,
		zoomInscriptionTypeId, place
	} = step2.part2;
	const {
		quantityVacancy, publicLoad
	} = step2.part3;
	const { autoCertificate } = step2.part4;
	const newErrors = {
		part1: {
			organizerId: organizerId === 0,
			teacher: {
				search: false,
				free: {
					fullName: false,
					accountId: false,
				},
			},
			payGradeId: !isValidPayGradeId({ eventTypeId, payGradeId }),
			placeOrganization: {
				campus: false,
			},
		},
		part2: {
			locationId: locationId === 0,
			zoomInscriptionTypeId: false,
			zoomTypeId: false,
			place: {
				campus: false,
				environment: {
					inCampus: {
						envId: false,
						floor: false,
					},
					outCampus: {
						internalOrExternal: false,
						address: false,
					},
					any: false,
				},
			},
		},
		part3: {
			quantityVacancy:
				!quantityVacancy.trim() || parseInt(quantityVacancy) <= 0,
			publicLoad: {
				id: publicLoad.id === 0,
				students: {
					publicByCampusIds: false,
					modalityId: false,
				},
				list: {
					studentsFile: false,
				},
			},
		},
		part4: {
			autoCertificate: {
				signatureCount: false,
				signatures: false,
				duplicateTypes: false,
				invalidValidity: false,
				signatureItems: autoCertificate.signatures.map(() => ({
					signatureTypeCode: false,
					utpCode: false,
					fullName: false,
				})),
			},
		},
	};
	if (organizerId > 0) {
		const teacherFreeFullName = teacher.free.fullName.trim();
		const teacherSearchId = teacher.search.id.trim();
		if (organizerId !== 1 && organizerId !== 6) {
			newErrors.part1.teacher.free = {
				fullName: !teacherFreeFullName,
				accountId: locationId === 1 && teacher.free.accountId === 0,
			};
		} else {
			if (!teacherFreeFullName && !teacherSearchId) {
				newErrors.part1.teacher = {
					search: teacher.free.accountId === 0,
					free: {
						fullName: true,
						accountId: locationId === 1,
					},
				};
			} else {
				newErrors.part1.teacher = {
					search:
						!teacherFreeFullName &&
						teacher.free.accountId === 0 &&
						!teacherSearchId,
					free: {
						fullName: !teacherSearchId && !teacherFreeFullName,
						accountId:
							!teacherSearchId &&
							locationId === 1 &&
							teacher.free.accountId === 0,
					},
				};
			}
		}
	}
	if (locationId === 1) {
		if (teacherZoomAccountDetail?.guests)
			newErrors.part2.zoomTypeId = zoomTypeId === 0;
		newErrors.part2.zoomInscriptionTypeId = zoomInscriptionTypeId === 0;
	} else if (locationId === 2) {
		const { inCampus, outCampus } = place.environment;
		newErrors.part2.place = {
			campus: place.campus.id === 0,
			environment: {
				inCampus: {
					// Si campos de fuera de campus están vacíos, se valida envId
					envId:
						!outCampus.internalOrExternal.trim() &&
						!outCampus.address.trim() &&
						inCampus.id === 0,
					// Si campos de fuera de campus están vacíos, se valida floor
					floor:
						!inCampus.floor.trim() &&
						!outCampus.internalOrExternal.trim() &&
						!outCampus.address.trim(),
				},
				outCampus: {
					// Si campos de dentro de campus están vacíos, se valida internalOrExternal
					internalOrExternal:
						inCampus.id === 0 &&
						!inCampus.floor.trim() &&
						!outCampus.internalOrExternal.trim(),
					// Si campos de dentro de campus están vacíos, se valida address
					address:
						inCampus.id === 0 &&
						!inCampus.floor.trim() &&
						!outCampus.address.trim(),
				},
			},
		};
	}
	if (publicLoad.id === 1) {
		const { publicByCampusIds, modalityId } = publicLoad.students;
		newErrors.part3.publicLoad.students = {
			publicByCampusIds: publicByCampusIds.length === 0,
			modalityId: modalityId === 0,
		};
	} else if (publicLoad.id === 2) {
		const { studentsFile } = publicLoad.list;
		newErrors.part3.publicLoad.list = {
			studentsFile: !studentsFile.name,
		};
	}
	if (autoCertificate.enabled) {
		const signatureCount = Number(autoCertificate.signatureCount) || 0;
		const selectedSignatures = autoCertificate.signatures.filter(
			({ signatureTypeCode }) => Boolean(signatureTypeCode)
		);
		newErrors.part4.autoCertificate.signatureCount =
			signatureCount < 1 || signatureCount > 3;
		newErrors.part4.autoCertificate.signatures =
			selectedSignatures.length !== signatureCount;
		newErrors.part4.autoCertificate.duplicateTypes =
			hasDuplicateSignatureTypes(autoCertificate.signatures);
		if (placeOrganization.campus.id === 0) {
			newErrors.part1.placeOrganization.campus = true;
			newErrors.part4.autoCertificate.signatures = true;
		}
		newErrors.part4.autoCertificate.signatureItems =
			autoCertificate.signatures.map(signature => ({
				signatureTypeCode: !signature.signatureTypeCode,
				utpCode: false,
				fullName:
					signatureRequiresSpeakerData(signature.signatureTypeCode) &&
					!isCertificationSpeakerResolved(signature),
			}));
		newErrors.part4.autoCertificate.invalidValidity =
			autoCertificate.signatures.some(
				signature =>
					isInstitutionalCertificationSignature(
						signature.signatureTypeCode
					) &&
					signature.sourceStatus ===
						CERTIFICATION_SIGNATURE_SOURCE_STATUS.INVALID_CAMPUS_OR_EVENT_END_DATE
			);
	}
	// if (placeOrganization.campus.id === 0) {
	// 	const { inCampus, outCampus } = placeOrganization.environment;
	// 	newErrors.part1.placeOrganization = {
	// 		campus: placeOrganization.campus.id === 0,
	// 		environment: {
	// 			inCampus: {
	// 				// Si campos de fuera de campus están vacíos, se valida envId
	// 				envId:
	// 					!outCampus.internalOrExternal.trim() &&
	// 					!outCampus.address.trim() &&
	// 					inCampus.id === 0,
	// 				// Si campos de fuera de campus están vacíos, se valida floor
	// 				floor:
	// 					!inCampus.floor.trim() &&
	// 					!outCampus.internalOrExternal.trim() &&
	// 					!outCampus.address.trim(),
	// 			},
	// 			outCampus: {
	// 				// Si campos de dentro de campus están vacíos, se valida internalOrExternal
	// 				internalOrExternal:
	// 					inCampus.id === 0 &&
	// 					!inCampus.floor.trim() &&
	// 					!outCampus.internalOrExternal.trim(),
	// 				// Si campos de dentro de campus están vacíos, se valida address
	// 				address:
	// 					inCampus.id === 0 &&
	// 					!inCampus.floor.trim() &&
	// 					!outCampus.address.trim(),
	// 			},
	// 		},
	// 	};
	// }
	const isValid = errorFree(newErrors);
	return {
		isValid,
		newErrors,
	};
};
//#endregion

const validations = {
	isValidFormStep1,
	isValidFormStep2,
};
export default validations;
